import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-14987aae"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  ref: "audioRef",
  controls: "",
  preload: "meta",
  class: "audio-player"
};
var _hoisted_2 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "audio-container",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return _ctx.toggle && _ctx.toggle.apply(_ctx, args);
    })
  }, [_createElementVNode("audio", _hoisted_1, [_createElementVNode("source", {
    src: _ctx.audioUrl,
    type: "audio/mpeg"
  }, null, 8, _hoisted_2)], 512)]);
}